import type { ButtonHTMLAttributes, ReactNode } from 'react';
import './Button.css';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  children: ReactNode;
}

/**
 * Pure presentational button. No data-fetching or business logic —
 * per Clean Architecture rules, this component must remain framework-UI only.
 */
export function Button({ variant = 'primary', className, children, ...rest }: ButtonProps) {
  const variantClass = variant === 'primary' ? 'dma-button--primary' : 'dma-button--secondary';
  const classes = ['dma-button', variantClass, className].filter(Boolean).join(' ');

  return (
    <button className={classes} {...rest}>
      {children}
    </button>
  );
}
